import * as GLOBAL_ACTION_TYPE from "./actionTypes";
import constant from "../constants/constantFile";
import { GafOktaManager } from "../auth/gaf-okta-auth";
import { removeWindowBeforeUnload } from "../utils/utils";

/**
 * Actions which indicates update screen resolution
 * @param {object} resolution - consist width and height
 * @ignore
 */
export function updateScreenResolution(resolution) {
    return {
        type: GLOBAL_ACTION_TYPE.UPDATE_SCREEN_RESOLUTION,
        payload: {
            resolution,
        },
    };
}

/**
 * Actions which indicates update global error message
 * @param {object} error - consist message
 * @ignore
 */
export function showGlobalError(error) {
    const errorCode =
        (error &&
            error.response &&
            ((error.response.data && error.response.data.StatusCode) || error.response.status)) ||
        "";
    if (errorCode === 401) {
        sessionStorage.setItem("requestURL", window.location.href);
        removeWindowBeforeUnload();
        GafOktaManager.getRenewToken();
    }
    let errMsg = (errorCode === 400 && error.response.data.Message) || error.Message || "";
    if (errMsg && errMsg.length > 150) {
        errMsg = errMsg.substring(0, 150) + "...";
    }
    return {
        type: GLOBAL_ACTION_TYPE.SHOW_GLOBAL_ERROR,
        payload: {
            errorMessage: constant.defaultApiErrorMessage + (errMsg ? "|" + errMsg : ""),
            errorCode: errorCode,
        },
    };
}
export function showGlobalSuccssMsg(action) {
    return {
        type: GLOBAL_ACTION_TYPE.SHOW_GLOBAL_SUCCESSMSG,
        payload: {
            successMessage: action,
        },
    };
}

/**
 * Actions which indicates clear / remove
 * the global error message
 * @ignore
 */
export function clearGlobalError() {
    return {
        type: GLOBAL_ACTION_TYPE.CLEAR_GLOBAL_ERROR,
    };
}

export function clearGlobalSuccessMsg() {
    return {
        type: GLOBAL_ACTION_TYPE.CLEAR_GLOBAL_SUCCESSMSG,
    };
}
/**
 * Actions which indicates update the active screen
 * @param {object} screen - either NewForm / draftList
 * @ignore
 */
export function updateActiveScreen(screen) {
    return {
        type: GLOBAL_ACTION_TYPE.UPDATE_ACTIVE_SCREEN,
        payload: {
            screen,
        },
    };
}

/**
 * Actions which indicates update the api loading / not
 * @param {boolean} loading
 * @ignore
 */
export function updateLoading(loading) {
    return {
        type: GLOBAL_ACTION_TYPE.API_LOADING,
        payload: {
            loading,
        },
    };
}
/**
 * Actions which indicates access Denied error message
 * @ignore
 */
export function showAccessDeniedError(accessDeniedError) {
    return {
        type: GLOBAL_ACTION_TYPE.SHOW_ACCESS_DENIED_ERROR,
        payload: {
            accessDeniedMessage: accessDeniedError.Message || constant.accessDeniedErrorMessage,
        },
    };
}

/**
 * Actions which indicates clear / remove
 * the access Denied error message
 * @ignore
 */
export function clearAccessDeniedError() {
    return {
        type: GLOBAL_ACTION_TYPE.CLEAR_ACCESS_DENIED_ERROR,
    };
}
